import utilsCommon from "../../../shared/utils/common";

const timezone = [
  {
    id: "Pacific/Midway",
    ko: "미드웨이 제도, 사모아",
    en: "Midway Island, Samoa",
    offset: 0,
  },
  {
    id: "Pacific/Pago_Pago",
    ko: "파고파고",
    en: "Pago Pago",
    offset: 0,
  },
  {
    id: "Pacific/Honolulu",
    ko: "하와이",
    en: "Hawaii",
    offset: 0,
  },
  {
    id: "America/Anchorage",
    ko: "알래스카",
    en: "Alaska",
    offset: 0,
  },
  { id: "America/Juneau", ko: "주노", en: "Juneau", offset: 0 },
  {
    id: "America/Vancouver",
    ko: "밴쿠버",
    en: "Vancouver",
    offset: 0,
  },
  {
    id: "America/Los_Angeles",
    ko: "태평양 표준시(미국 및 캐나다)",
    en: "Pacific Time (US and Canada)",
    offset: 0,
  },
  {
    id: "America/Tijuana",
    ko: "티후아나",
    en: "Tijuana",
    offset: 0,
  },
  {
    id: "America/Phoenix",
    ko: "애리조나",
    en: "Arizona",
    offset: 0,
  },
  {
    id: "America/Edmonton",
    ko: "에드먼턴",
    en: "Edmonton",
    offset: 0,
  },
  {
    id: "America/Denver",
    ko: "산지 표준시(미국 및 캐나다)",
    en: "Mountain Time (US and Canada)",
    offset: 0,
  },
  {
    id: "America/Mazatlan",
    ko: "마사틀란",
    en: "Mazatlan",
    offset: 0,
  },
  {
    id: "America/Regina",
    ko: "서스캐처원",
    en: "Saskatchewan",
    offset: 0,
  },
  {
    id: "America/Guatemala",
    ko: "과테말라",
    en: "Guatemala",
    offset: 0,
  },
  {
    id: "America/El_Salvador",
    ko: "엘살바도르",
    en: "El Salvador",
    offset: 0,
  },
  {
    id: "America/Managua",
    ko: "마나과",
    en: "Managua",
    offset: 0,
  },
  {
    id: "America/Costa_Rica",
    ko: "코스타리카",
    en: "Costa Rica",
    offset: 0,
  },
  {
    id: "America/Tegucigalpa",
    ko: "테구시갈파",
    en: "Tegucigalpa",
    offset: 0,
  },
  {
    id: "America/Chihuahua",
    ko: "치와와",
    en: "Chihuahua",
    offset: 0,
  },
  {
    id: "America/Winnipeg",
    ko: "위니펙",
    en: "Winnipeg",
    offset: 0,
  },
  {
    id: "America/Chicago",
    ko: "중부 표준시(미국 및 캐나다)",
    en: "Central Time (US and Canada)",
    offset: 0,
  },
  {
    id: "America/Mexico_City",
    ko: "멕시코 시티",
    en: "Mexico City",
    offset: 0,
  },
  {
    id: "America/Panama",
    ko: "파나마",
    en: "Panama",
    offset: 0,
  },
  {
    id: "America/Bogota",
    ko: "보고타",
    en: "Bogota",
    offset: 0,
  },
  { id: "America/Lima", ko: " 리마", en: "Lima", offset: 0 },
  {
    id: "America/Monterrey",
    ko: "몬테레이",
    en: "Monterrey",
    offset: 0,
  },
  {
    id: "America/Montreal",
    ko: "몬트리올",
    en: "Montreal",
    offset: 0,
  },
  {
    id: "America/New_York",
    ko: "동부 표준시(미국 및 캐나다)",
    en: "Eastern Time (US and Canada)",
    offset: 0,
  },
  {
    id: "America/Indianapolis",
    ko: "인디애나(동부)",
    en: "Indiana (East)",
    offset: 0,
  },
  {
    id: "America/Puerto_Rico",
    ko: "푸에르토리코",
    en: "Puerto Rico",
    offset: 0,
  },
  {
    id: "America/Caracas",
    ko: "카라카스",
    en: "Caracas",
    offset: 0,
  },
  {
    id: "America/Santiago",
    ko: "산티아고",
    en: "Santiago",
    offset: 0,
  },
  {
    id: "America/La_Paz",
    ko: "라파스",
    en: "La Paz",
    offset: 0,
  },
  {
    id: "America/Guyana",
    ko: "가이아나",
    en: "Guyana",
    offset: 0,
  },
  {
    id: "America/Halifax",
    ko: "핼리팩스",
    en: "Halifax",
    offset: 0,
  },
  {
    id: "America/Montevideo",
    ko: "몬테비디오",
    en: "Montevideo",
    offset: 0,
  },
  {
    id: "America/Araguaina",
    ko: "레시페",
    en: "Recife",
    offset: 0,
  },
  {
    id: "America/Argentina/Buenos_Aires",
    ko: "부에노스아이레스, 조지타운",
    en: "Buenos Aires, Georgetown",
    offset: 0,
  },
  {
    id: "America/Sao_Paulo",
    ko: "상파울루",
    en: "Sao Paulo",
    offset: 0,
  },
  {
    id: "Canada/Atlantic",
    ko: "대서양 표준시(캐나다)",
    en: "Atlantic Time (Canada)",
    offset: 0,
  },
  {
    id: "America/St_Johns",
    ko: "뉴펀들랜드 및 래브라도",
    en: "Newfoundland and Labrador",
    offset: 0,
  },
  {
    id: "America/Godthab",
    ko: "그린란드",
    en: "Greenland",
    offset: 0,
  },
  {
    id: "Atlantic/Cape_Verde",
    ko: "카보베르데 제도",
    en: "Cape Verde Islands",
    offset: 0,
  },
  {
    id: "Atlantic/Azores",
    ko: "아조레스",
    en: "Azores",
    offset: 0,
  },
  {
    id: "UTC",
    ko: "세계 표준시 UTC",
    en: "Universal Time UTC",
    offset: 0,
  },
  {
    id: "Etc/Greenwich",
    ko: "그리니치 표준시",
    en: "Greenwich Mean Time",
    offset: 0,
  },
  {
    id: "Atlantic/Reykjavik",
    ko: "레이캬비크",
    en: "Reykjavik",
    offset: 0,
  },
  {
    id: "Africa/Nouakchott",
    ko: "누악쇼트",
    en: "Nouakchott",
    offset: 0,
  },
  { id: "Europe/Dublin", ko: "더블린", en: "Dublin", offset: 0 },
  { id: "Europe/London", ko: "런던", en: "London", offset: 0 },
  { id: "Europe/Lisbon", ko: "리스본", en: "Lisbon", offset: 0 },
  {
    id: "Africa/Casablanca",
    ko: "카사블랑카",
    en: "Casablanca",
    offset: 0,
  },
  {
    id: "Africa/Bangui",
    ko: "서중앙 아프리카",
    en: "West Central Africa",
    offset: 0,
  },
  { id: "Africa/Algiers", ko: "알제", en: "Algiers", offset: 0 },
  { id: "Africa/Tunis", ko: "튀니스", en: "Tunis", offset: 0 },
  {
    id: "Europe/Belgrade",
    ko: "베오그라드, 브라티슬라바, 류블랴나",
    en: "Belgrade, Bratislava, Ljubljana",
    offset: 0,
  },
  {
    id: "CET",
    ko: "사라예보, 스코페, 자그레브",
    en: "Sarajevo, Skopje, Zagreb",
    offset: 0,
  },
  { id: "Europe/Oslo", ko: "오슬로", en: "Oslo", offset: 0 },
  {
    id: "Europe/Copenhagen",
    ko: "코펜하겐",
    en: "Copenhagen",
    offset: 0,
  },
  {
    id: "Europe/Brussels",
    ko: "브뤼셀",
    en: "Brussels",
    offset: 0,
  },
  {
    id: "Europe/Berlin",
    ko: "암스테르담, 베를린, 로마, 스톡홀름, 비엔나",
    en: "Amsterdam, Berlin, Rome, Stockholm, Vienna",
    offset: 0,
  },
  {
    id: "Europe/Amsterdam",
    ko: "암스테르담",
    en: "Amsterdam",
    offset: 0,
  },
  { id: "Europe/Rome", ko: "로마", en: "Rome", offset: 0 },
  {
    id: "Europe/Stockholm",
    ko: "스톡홀름",
    en: "Stockholm",
    offset: 0,
  },
  { id: "Europe/Vienna", ko: "비엔나", en: "Vienna", offset: 0 },
  {
    id: "Europe/Luxembourg",
    ko: "룩셈부르크",
    en: "Luxembourg",
    offset: 0,
  },
  { id: "Europe/Paris", ko: "파리", en: "Paris", offset: 0 },
  { id: "Europe/Zurich", ko: "취리히", en: "Zurich", offset: 0 },
  {
    id: "Europe/Madrid",
    ko: "마드리드",
    en: "Madrid",
    offset: 0,
  },
  {
    id: "Africa/Harare",
    ko: "하라레, 프리토리아",
    en: "Harare, Pretoria",
    offset: 0,
  },
  {
    id: "Europe/Warsaw",
    ko: "바르샤바",
    en: "Warsaw",
    offset: 0,
  },
  {
    id: "Europe/Prague",
    ko: "프라하 브라티슬라바",
    en: "Prague Bratislava",
    offset: 0,
  },
  {
    id: "Europe/Budapest",
    ko: "부다페스트",
    en: "Budapest",
    offset: 0,
  },
  {
    id: "Africa/Tripoli",
    ko: "트리폴리",
    en: "Tripoli",
    offset: 0,
  },
  { id: "Africa/Cairo", ko: "카이로", en: "Cairo", offset: 0 },
  {
    id: "Africa/Johannesburg",
    ko: "요하네스버그",
    en: "Johannesburg",
    offset: 0,
  },
  {
    id: "Africa/Khartoum",
    ko: "카르툼",
    en: "Khartoum",
    offset: 0,
  },
  {
    id: "Europe/Helsinki",
    ko: "헬싱키",
    en: "Helsinki",
    offset: 0,
  },
  {
    id: "Africa/Nairobi",
    ko: "나이로비",
    en: "Nairobi",
    offset: 0,
  },
  { id: "Europe/Sofia", ko: "소피아", en: "Sofia", offset: 0 },
  {
    id: "Europe/Istanbul",
    ko: "이스탄불",
    en: "Istanbul",
    offset: 0,
  },
  { id: "Europe/Athens", ko: "아테네", en: "Athens", offset: 0 },
  {
    id: "Europe/Bucharest",
    ko: "부카레스트",
    en: "Bucharest",
    offset: 0,
  },
  {
    id: "Asia/Nicosia",
    ko: "니코시아",
    en: "Nicosia",
    offset: 0,
  },
  { id: "Asia/Beirut", ko: "베이루트", en: "Beirut", offset: 0 },
  {
    id: "Asia/Damascus",
    ko: "다마스쿠스",
    en: "Damascus",
    offset: 0,
  },
  {
    id: "Asia/Jerusalem",
    ko: "예루살렘",
    en: "Jerusalem",
    offset: 0,
  },
  { id: "Asia/Amman", ko: "암만", en: "Amman", offset: 0 },
  {
    id: "Europe/Moscow",
    ko: "모스크바",
    en: "Moscow",
    offset: 0,
  },
  {
    id: "Asia/Baghdad",
    ko: "바그다드",
    en: "Baghdad",
    offset: 0,
  },
  { id: "Asia/Kuwait", ko: "쿠웨이트", en: "Kuwait", offset: 0 },
  { id: "Asia/Riyadh", ko: "리야드", en: "Riyadh", offset: 0 },
  { id: "Asia/Bahrain", ko: "바레인", en: "Bahrain", offset: 0 },
  { id: "Asia/Qatar", ko: "카타르", en: "Qatar", offset: 0 },
  { id: "Asia/Aden", ko: "아덴", en: "Aden", offset: 0 },
  {
    id: "Africa/Djibouti",
    ko: "지부티",
    en: "Djibouti",
    offset: 0,
  },
  {
    id: "Africa/Mogadishu",
    ko: "모가디슈",
    en: "Mogadishu",
    offset: 0,
  },
  { id: "Europe/Kiev", ko: "키예프", en: "Kiev", offset: 0 },
  { id: "Europe/Minsk", ko: "민스크", en: "Minsk", offset: 0 },
  { id: "Asia/Dubai", ko: "두바이", en: "Dubai", offset: 0 },
  { id: "Asia/Muscat", ko: "무스카트", en: "Muscat", offset: 0 },
  {
    id: "Asia/Baku",
    ko: "바쿠, 트빌리시, 예레반",
    en: "Baku, Tbilisi, Yerevan",
    offset: 0,
  },
  { id: "Asia/Tehran", ko: "테헤란", en: "Tehran", offset: 0 },
  { id: "Asia/Kabul", ko: "카불", en: "Kabul", offset: 0 },
  {
    id: "Asia/Yekaterinburg",
    ko: "예카테린부르크",
    en: "Yekaterinburg",
    offset: 0,
  },
  {
    id: "Asia/Tashkent",
    ko: "이슬라마바드, 카라치, 타슈켄트",
    en: "Islamabad, Karachi, Tashkent",
    offset: 0,
  },
  { id: "Asia/Calcutta", ko: "인도", en: "India", offset: 0 },
  {
    id: "Asia/Kolkata",
    ko: "뭄바이, 콜카타, 뉴델리",
    en: "Mumbai, Kolkata, New Delhi",
    offset: 0,
  },
  {
    id: "Asia/Kathmandu",
    ko: "카트만두",
    en: "Kathmandu",
    offset: 0,
  },
  { id: "Asia/Almaty", ko: "알마티", en: "Almaty", offset: 0 },
  { id: "Asia/Dacca", ko: "다카", en: "Dacca", offset: 0 },
  {
    id: "Asia/Dhaka",
    ko: "아스타나, 다카",
    en: "Astana, Dhaka",
    offset: 0,
  },
  { id: "Asia/Rangoon", ko: "랑군", en: "Rangoon", offset: 0 },
  {
    id: "Asia/Novosibirsk",
    ko: "노보시비르스크",
    en: "Novosibirsk",
    offset: 0,
  },
  {
    id: "Asia/Krasnoyarsk",
    ko: "크라스노야르스크",
    en: "Krasnoyarsk",
    offset: 0,
  },
  { id: "Asia/Bangkok", ko: "방콕", en: "Bangkok", offset: 0 },
  { id: "Asia/Saigon", ko: "베트남", en: "Vietnam", offset: 0 },
  {
    id: "Asia/Jakarta",
    ko: "자카르타",
    en: "Jakarta",
    offset: 0,
  },
  {
    id: "Asia/Irkutsk",
    ko: "이르쿠츠크, 울란바토르",
    en: "Irkutsk, Ulaanbaatar",
    offset: 0,
  },
  {
    id: "Asia/Shanghai",
    ko: "베이징, 상하이",
    en: "Beijing, Shanghai",
    offset: 0,
  },
  {
    id: "Asia/Hong_Kong",
    ko: "홍콩 특별 행정구",
    en: "Hong Kong SAR",
    offset: 0,
  },
  { id: "Asia/Taipei", ko: "타이페이", en: "Taipei", offset: 0 },
  {
    id: "Asia/Kuala_Lumpur",
    ko: "쿠알라룸푸르",
    en: "Kuala Lumpur",
    offset: 0,
  },
  {
    id: "Asia/Singapore",
    ko: "싱가포르",
    en: "Singapore",
    offset: 0,
  },
  { id: "Australia/Perth", ko: "퍼스", en: "Perth", offset: 0 },
  {
    id: "Asia/Yakutsk",
    ko: "야쿠츠크",
    en: "Yakutsk",
    offset: 0,
  },
  { id: "Asia/Seoul", ko: "서울", en: "Seoul", offset: 0 },
  {
    id: "Asia/Tokyo",
    ko: "오사카, 삿포로, 도쿄",
    en: "Osaka, Sapporo, Tokyo",
    offset: 0,
  },
  {
    id: "Australia/Darwin",
    ko: "다윈",
    en: "Darwin",
    offset: 0,
  },
  {
    id: "Australia/Adelaide",
    ko: "애들레이드",
    en: "Adelaide",
    offset: 0,
  },
  {
    id: "Asia/Vladivostok",
    ko: "블라디보스토크",
    en: "Vladivostok",
    offset: 0,
  },
  {
    id: "Pacific/Port_Moresby",
    ko: "괌, 포트모르즈비",
    en: "Guam, Port Moresby",
    offset: 0,
  },
  {
    id: "Australia/Brisbane",
    ko: "브리즈번",
    en: "Brisbane",
    offset: 0,
  },
  {
    id: "Australia/Sydney",
    ko: "캔버라, 멜버른, 시드니",
    en: "Canberra, Melbourne, Sydney",
    offset: 0,
  },
  {
    id: "Australia/Hobart",
    ko: "호바트",
    en: "Hobart",
    offset: 0,
  },
  {
    id: "Asia/Magadan",
    ko: "마가단",
    en: "Magadan",
    offset: 0,
  },
  {
    id: "Pacific/Noumea",
    ko: "뉴칼레도니아",
    en: "New Caledonia",
    offset: 0,
  },
  {
    id: "Asia/Kamchatka",
    ko: "캄차카",
    en: "Kamchatka",
    offset: 0,
  },
  {
    id: "Pacific/Fiji",
    ko: "피지 제도, 마샬 제도",
    en: "Fiji Islands, Marshall Islands",
    offset: 0,
  },
  {
    id: "Pacific/Auckland",
    ko: "오클랜드, 웰링턴",
    en: "Auckland, Wellington",
    offset: 0,
  },
  {
    id: "Pacific/Apia",
    ko: "사모아 독립국",
    en: "dependent State of Samoa",
    offset: 0,
  },
];
interface TimezoneDTO {
  id: string;
  ko: string;
  en: string;
  offset: number;
}

function compare(a: TimezoneDTO, b: TimezoneDTO) {
  // Use toUpperCase() to ignore character casing
  const offsetA = a.offset;
  const offsetB = b.offset;

  let comparison = 0;
  if (offsetA > offsetB) {
    comparison = 1;
  } else if (offsetA < offsetB) {
    comparison = -1;
  }
  return comparison;
}

timezone
  .filter((item) => !!item.id)
  .map((item) => (item.offset = utilsCommon.getTimeZoneOffset(item?.id)));
timezone.sort(compare);

export default timezone;
